<template>
  <el-radio-group v-model="modelValue"
    class="ticket_form_radio"
    @change="onChange">
    <el-radio v-for="e in item.enums"
      :key="e.id"
      :label="e.id">{{e.name}}</el-radio>
  </el-radio-group>
</template>

<style>
.ticket_form_radio .el-radio__label {
  word-break: break-all;
  white-space: pre-wrap!important;
}
</style>

<script>
export default {
    name : 'TicketFormRadio',

    props : ['value', 'item'],

    data() {
      return {
        modelValue : []
      }
    },

    watch : {
      value() {
        this.modelValue = this.value;
      }
    },

    mounted() {
      this.modelValue = this.value;
    },

    methods : {
      onChange() {
        this.$emit('input', this.modelValue);

        this.$emit('change', this.modelValue);
      }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/ticket/TicketFormRadio.vue